import { reactive, set, toRefs } from '@vue/composition-api'
import httpService from '@/core/http-service'
import _ from 'lodash'
import useNodeHierarchy from '@/composables/useNodeHierarchy'

export default function useProductRelatedNodeData(model) {
  const hierarchy = useNodeHierarchy(getChildren)

  const state = reactive({
    initialData: {},
    flattenedData: []
  })

  function getChildren(code) {
    return _.get(_.find(state.flattenedData, item => item.code === code), 'nextLevel') || []
  }

  function saveFlatStructure(data) {
    const result = []

    function recurse(item) {
      if (!item) return
      result.push(item)
      if (item.nextLevel && item.nextLevel.length) {
        item.nextLevel.forEach(recurse)
      }
    }
    data.forEach(recurse)
    state.flattenedData = result
  }

  function verifyCodes(codes) {
    const availableCodes = _.map(state.flattenedData, 'code')
    return codes.every(code => availableCodes.includes(code))
  }

  async function initializeNodeData() {
    const { data } = await httpService.get('fitsfor', { ...model, linkToProduct: true })
    state.initialData = data
    saveFlatStructure(data)
    const children = _.map(data, item => { return { code: item.code, name: item.name } })
    set(hierarchy.nodeData.value, 0, { node: { code: 'root' }, children })

    if (model.currentVehicle) {
      const codes = await hierarchy.getNodeCodeHierarchy(model.currentVehicle)
      if(verifyCodes(codes)) {
        await hierarchy.prePopulateSelections(codes)
      }
    }

    hierarchy.selectedNodeData.value = _.cloneDeep(hierarchy.nodeData.value)
    hierarchy.initialized.value = true
  }

  return {
    ...toRefs(state),
    ...hierarchy,
    initializeNodeData
  }
}
